import { render, staticRenderFns } from "./SelectOrCreate.vue?vue&type=template&id=21e6f70e&scoped=true&"
import script from "./SelectOrCreate.vue?vue&type=script&lang=js&"
export * from "./SelectOrCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e6f70e",
  null
  
)

export default component.exports